module.exports = __webpack_public_path__ + "img/RoterPanda.3ac03499.svg";